const GA_TRACKING_ID = 'G-34YMNXSXY4' // Google id
const analysis = function (eventActionIndex) {
  const ga = ['GooglePlay预约按钮', 'onestore预约按钮', '号码提交按钮', '转盘点击按钮', '播放视频按钮']
  const fb = ['加入购物车', '加入心愿单', '完成注册', '发起结账', '提交试用']
  if (window.gtag) {
    window.gtag('event', ga[eventActionIndex], {
      send_to: GA_TRACKING_ID
    })
  }
  fbq('trackCustom', fb[eventActionIndex])
}
export { analysis }
